import { render, staticRenderFns } from "./PasswordRedPacket.vue?vue&type=template&id=427e0c1c&scoped=true&"
import script from "./PasswordRedPacket.vue?vue&type=script&lang=js&"
export * from "./PasswordRedPacket.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRedPacket.vue?vue&type=style&index=0&id=427e0c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e0c1c",
  null
  
)

export default component.exports